import { DocumentForm } from '@crm/components'
import { useLocales } from '@shared/locales'
import { Modal } from 'antd'

import { ActionsType } from './types'

const formName = 'add-edit-document-form'

type Props = { document?: ActionsType['document'] } & Omit<
  ActionsType,
  'document'
>

export const AddEditDocument = ({ document, ...props }: Props) => {
  const { t } = useLocales()

  return (
    <Modal
      width={800}
      maskClosable={false}
      title={t('lead.documents')}
      cancelText={t('buttons.cancel')}
      okText={t('buttons.save')}
      okButtonProps={{
        htmlType: 'submit',
        form: formName
      }}
      {...props}
    >
      <DocumentForm
        id={document?.id}
        formName={formName}
        closeModal={props.onCancel}
      />
    </Modal>
  )
}
